/**
 * Tax – Thresholds
 */

export default {
  threshold: {
    dashboard: "Dashboard",
    notFilled: `You don't have filled TAX return.`,
    thresholdsFor1: "Thresholds for ",
    thresholdsFor2: " year",
    us: "US",
    eu: "EU",
    row: "ROW",
    fed: "Federal",
    rowFull: "Rest of world",
    calc: "Calculate",
    janSh: "Jan",
    febSh: "Feb",
    marSh: "Mar",
    aprSh: "Apr",
    maySh: "May",
    juneSh: "Jun",
    julySh: "Jul",
    augSh: "Aug",
    septSh: "Sep",
    octSh: "Oct",
    novSh: "Nov",
    decSh: "Dec",
    state: "State",
    country: "Country",
    countryReg: "Country (region)",
    thresholdSum: "Threshold amount",
    factSum: "Fact amount",
    thresholdTrans: "Threshold transaction",
    factTrans: "Fact transaction",
    type: "Type",
  },
};
